import { render, staticRenderFns } from "./student-notes.vue?vue&type=template&id=154c93a0&scoped=true&"
import script from "./student-notes.vue?vue&type=script&lang=js&"
export * from "./student-notes.vue?vue&type=script&lang=js&"
import style0 from "./student-notes.vue?vue&type=style&index=0&id=154c93a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154c93a0",
  null
  
)

component.options.__file = "student-notes.vue"
export default component.exports